// src/index.ts
var baseFont1 = "Arial";
var baseFont2 = "Comic Sans MS";
var getTextWidth = (fontFamily, dummyText) => {
  const span = document.createElement("span");
  span.style.visibility = "hidden";
  span.style.pointerEvents = "none";
  span.style.position = "absolute";
  span.style.whiteSpace = "nowrap";
  span.style.opacity = "0";
  span.innerHTML = dummyText;
  span.style.fontFamily = fontFamily;
  document.body.appendChild(span);
  const { width } = span.getBoundingClientRect();
  document.body.removeChild(span);
  return width;
};
var isFontInstalledBase = (dummyText) => (fontFamily) => {
  return !(getTextWidth(baseFont1, dummyText) === getTextWidth(fontFamily + ", " + baseFont1, dummyText) && getTextWidth(baseFont2, dummyText) === getTextWidth(fontFamily + ", " + baseFont2, dummyText));
};
var isFontInstalled = isFontInstalledBase("Thequickbrownfoxjumps");
var isFontInstalledCyrillic = isFontInstalledBase("\u0423\u043B\u0443\u043A\u043E\u043C\u043E\u0440\u044C\u044F\u0434\u0443\u0431\u0437\u0435\u043B\u0435\u043D\u044B\u0439\u0437\u043B\u0430\u0442\u0430\u044F\u0446\u0435\u043F\u044C\u043D\u0430\u0434\u0443\u0431\u0435\u0442\u043E\u043C");
var isFontInstalledExtLat = isFontInstalledBase("Po\xE7\u017Ee\u015B\xEFtem\xF1\xEAsp\xEC\xF1k\xFA");
var src_default = isFontInstalled;
export {
  src_default as default,
  isFontInstalledCyrillic,
  isFontInstalledExtLat
};
//# sourceMappingURL=index.mjs.map